import { statuses, floorsList, paymentMethods, heightsList, units, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, alertDialog, noSelected, } from 'i18n/ru.common';
export default {
    translation: {
        heightsList,
        main: {
            confirmationDialog: {
                accept: 'Подтвердить',
                cancel: 'Отменить',
            },
            controls: {
                top: {
                    projectList: 'Список проектов',
                    statisticsButton: 'Показать статистику',
                    layersButton: 'Слои',
                    layers: {
                        metro: 'Метро',
                        places: 'Места',
                        districts: 'Районы',
                        emirates: {
                            AE: 'Эмираты',
                            default: 'Регионы',
                        },
                    },
                },
                middle: {
                    errorAddProject: 'Размещение проекта возможно только в пределах района',
                    errorAddDistrict: {
                        AE: 'Размещение района возможно только в пределах эмирата',
                        default: 'Размещение района возможно только в пределах региона',
                    },
                    addNewObject: 'Добавить объект',
                    adminWidget: {
                        project: 'Проект',
                        district: 'Район',
                        emirate: {
                            AE: 'Эмират',
                            default: 'Регион',
                        },
                        preLaunch: 'Предзапуск',
                    },
                },
                bottom: {
                    catalog: 'Каталог',
                },
            },
            metroStation: {
                line: '{{lineCode}} линия',
                plannedStation: 'планируемая станция',
                builtStation: 'построенная станция',
                subtitle: 'Станция метро',
            },
            searchKeywords: {
                title: 'Ключевые слова для поиска',
                add: 'Добавить',
                placeholder: 'Введите название',
                tooltip: 'Ключевые слова, по которым можно найти проект в поиске.',
            },
            projectEdit: {
                create: 'Создание проекта',
                edit: '',
                description: 'Описание',
                save: 'Сохранить',
                catalogPreview: 'Предпросмотр каталога',
                unitsStockUpdated: {
                    minutes_one: 'Сток юнитов обновлён {{count}} минуту назад',
                    minutes_few: 'Сток юнитов обновлён {{count}} минуты назад',
                    minutes_many: 'Сток юнитов обновлён {{count}} минут назад',
                    minutes_other: 'Сток юнитов обновлён {{count}} минут назад',
                    hours_one: 'Сток юнитов обновлён {{count}} час назад',
                    hours_few: 'Сток юнитов обновлён {{count}} часа назад',
                    hours_many: 'Сток юнитов обновлён {{count}} часов назад',
                    hours_other: 'Сток юнитов обновлён {{count}} часов назад',
                    days_one: 'Сток юнитов обновлён {{count}} день назад',
                    days_few: 'Сток юнитов обновлён {{count}} дня назад',
                    days_many: 'Сток юнитов обновлён {{count}} дней назад',
                    days_other: 'Сток юнитов обновлён {{count}} дней назад',
                },
                deleteDialog: {
                    title: 'Удаление проекта',
                    message: 'Реально удалить? \nВосстановить будет нельзя, это всё... С концами!',
                },
                closeDialog: {
                    title: 'Выйти из редактирования проекта?',
                    message: 'Вы не сохранили изменения в проекте. \n Все несохраненные данные будут потеряны.',
                },
                tabs: {
                    information: 'Информация',
                    configurations: 'Конфигурации',
                    transactions: 'Транзакции',
                    typicalUnits: 'Типовые юниты',
                    units: 'Юниты',
                    amenities: 'Удобства',
                    paymentPlans: 'Старый план оплаты',
                    paymentPlansNew: 'Новый план оплаты',
                    documentsAndVideos: 'Документы и видео',
                    '3d': '3D Модели',
                },
                information: {
                    name: 'Название',
                    namePlaceholder: 'Название',
                    add: 'Добавить',
                    description: 'Описание',
                    note: 'Заметки проекта {{symbols}}/{{maxSymbols}} символов',
                    notePlaceholder: 'Please enter your note',
                    developer: 'Застройщик',
                    seller: 'Продавец',
                    developerPlaceholder: 'Не выбран',
                    sellerPlaceholder: 'Не выбран',
                    ownershipType: 'Тип владения',
                    ownershipTypePlaceholder: 'Выберите',
                    postHandover: 'Постоплата',
                    handover: 'Срок сдачи',
                    serviceCharge: {
                        TH: 'Обслуживание',
                        default: 'Обслуживание',
                    },
                    minCommission: 'Комиссия от',
                    maxCommission: 'Комиссия до',
                    furnishing: 'Отделка',
                    startOfSales: 'Старт продаж',
                    eoi: 'Взнос по EOI',
                    eoiTitle: {
                        MX: 'Платёж за бронирование',
                        default: 'Взнос по EOI',
                    },
                    eoiFrom: 'От',
                    eoiTo: 'До',
                    eoiAmount: 'Сумма',
                    eoiPercentage: 'Процент',
                    eoiHint: 'Введите оба значения для диапазона или одно — для минимума или максимума. Одинаковые значения в обоих полях задают точное значение.',
                    eoiNotProvided: 'Не указано',
                    eoiMinFrom: 'Поле eoi from должно быть больше 0.',
                    eoiMinTo: 'Поле eoi to должно быть больше 0.',
                    eoiRangeFrom: 'Должно быть не больше {{max}}',
                    eoiRangeTo: 'Должно быть не меньше {{min}}',
                    noc: 'Перепродажа разрешена после',
                    isPreLaunch: {
                        MX: 'Предзапуск',
                        default: 'Предзапуск',
                    },
                    preLaunchHint: {
                        MX: 'Платёж за бронирование и старт продаж применяются только к проектам на предзапуске. Снятие чекбокса удалит оба значения.',
                        default: 'Взнос по EOI и старт продаж применяются только к проектам на предзапуске. Снятие чекбокса удалит оба значения.',
                    },
                    isPublished: 'Опубликовано',
                    unpublishPriorityDialog: {
                        title: 'Проект продвигается',
                        text: 'Этот проект сейчас продвигается. Если снять его с публикации, продвижение остановится, а потраченный бюджет не вернётся. Продолжить?',
                        unpublish: 'Снять с публикации',
                        cancel: 'Отмена',
                    },
                    isExclusive: 'Эксклюзив',
                    hasUnitsOnRequest: 'Есть юниты по запросу',
                    save: 'Сохранить',
                    architecture: 'Architecture',
                    interior: 'Interior',
                    amenities: 'Amenities',
                    projectLocation: 'Расположение проекта (координаты)',
                    projectLocationPlaceholder: 'Вставьте координаты',
                    common: 'Общие',
                    has3DModel: 'Есть 3Д модель',
                    logoHint: 'По умолчанию используется логотип застройщика/продавца. Загрузите свой, если хотите.',
                    customLogo: 'Свой логотип',
                    logoReset: 'Сбросить',
                    logoSellerChangedNote: 'Вы выбрали другого продавца. Если кастомный логотип больше не нужен, сбросьте его',
                    logoDeveloperChangedNote: 'Вы выбрали другого застройщика. Если кастомный логотип больше не нужен, сбросьте его',
                    addNewItems: {
                        title: 'Ключевые слова для поиска',
                        addText: 'Добавить',
                        placeholder: 'Введите название',
                        tooltip: 'Ключевые слова, по которым можно найти проект в поиске.',
                    },
                },
                configurations: {
                    config: 'Конфигурации',
                    add: 'Добавить конфигурацию',
                    deleteConfig: 'Удалить конфигурацию',
                    duplicate: 'Дублировать',
                    name: 'Название конфигурации',
                    description: 'Описание конфигурации',
                    configType: 'Тип конфигурации',
                    configTypePlaceholder: 'Тип конфигурации',
                    attachConfig: 'Новая конфигурация',
                    updateConfig: 'Обновленная конфигурация',
                },
                transactions: {
                    title: 'DLD ID',
                    addText: 'Добавить',
                    placeholder: 'Введите номер',
                    tooltip: 'DLD ID из реестра.',
                },
                paymentPlans: {
                    plan: 'План',
                    add: 'Добавить новый план',
                    postHandover: 'Пост оплата',
                    deletePlan: 'Удалить план',
                    name: 'Имя плана',
                    duplicate: 'Дублировать',
                    duplicateToOther: 'Дублировать в другой проект',
                    description: 'Описание плана',
                    downPayment: 'Downpayment',
                    underConstruction: 'Общий объём платежей до сдачи',
                    underConstructionPlaceholder: 'От 0% до 100%',
                    stepName: 'Имя этапа оплаты',
                    stepDescription: 'Описание этапа оплаты',
                    save: 'Сохранить',
                    ...paymentMethods,
                    duplicateModal: {
                        title: 'Дублирование плана оплаты',
                        message: 'Выберите проект, в который хотите дублировать план оплаты',
                        apply: 'Применить',
                        inputPlaceholder: 'Выберите проекты',
                        dropdownInputPlaceholder: 'Поиск',
                    },
                    successModal: {
                        title: 'Успешно дублирован',
                        text: '{{planName}} успешно скопирован в следующие проекты:',
                        ok: 'Ok',
                    },
                    errorModal: {
                        title: 'Ошибка',
                        ok: 'Ok',
                    },
                },
                paymentPlansNew: {
                    methods: {
                        title: 'Методы оплаты',
                        credit_debit_card: 'Карта',
                        cash: 'Наличные',
                        crypto: 'Криптовалюта',
                        bank_check: 'Чек',
                        bank_transfer: 'Банковский перевод',
                    },
                    plans: {
                        title: 'Планы оплаты',
                        addPlan: 'Новый план оплаты',
                        planItem: {
                            defaultName: 'Планы оплаты',
                            hasPostHandover: 'Has post handover',
                            noPostHandover: 'No post handover',
                            duplicate: 'Duplicate',
                            duplicateToOther: 'Duplicate into other project',
                            delete: 'Delete plan',
                            about: 'About plan',
                            switchLabel: 'Published',
                            titleEN: 'Plan name EN',
                            titleRU: 'Plan name RU',
                            placeholderEN: 'Name of plan',
                            placeholderRU: 'Название плана',
                            emptyFieldErr: 'Поле не должно быть пустым',
                            toastWarning: 'Нельзя копировать несохраненный план, сохраните его и попробуйте еще раз!',
                            stage: {
                                addPayment: 'Добавить платеж',
                                about: 'About payment',
                                when: 'When',
                                amount: 'Amount',
                                apply: 'Apply',
                                titleEN: 'Title EN',
                                titleRU: 'Title RU',
                                placeholderEN: 'Name of step',
                                placeholderRU: 'Название шага',
                                typeOfPayment: 'Type of payment',
                                trigger: 'Trigger',
                                switchRepeatPayments: 'Repeat payment',
                                refundable: 'Refundable',
                                value: 'Value',
                                typeAmount: 'Type amount',
                                intervalType: 'Interval type',
                                amountOfInterval: 'Amount of interval',
                                dateOfPayment: 'Date of payment',
                                constructionProgress: 'Construction progress',
                                repeatCount: 'How many times',
                                interval: 'Frequency',
                                frequency: 'Period',
                                dropdownEdit: 'Edit',
                                dropdownDuplicate: 'Duplicate',
                                dropdownDeleteStep: 'Delete step',
                                ready: 'готово',
                            },
                        },
                    },
                },
                amenities: {
                    save: 'Сохранить',
                },
                documents: {
                    add: 'Добавить',
                    save: 'Сохранить',
                    videos: {
                        title: 'Видео проекта',
                        documents: 'Документы',
                        add: 'Добавить',
                        vimeoLink: 'Vimeo ссылка',
                        titleOfTheLink: 'Название ссылки',
                        maxReached: 'Максимум 100 видео. Удалите одно, чтобы добавить другое.',
                    },
                },
                units: {
                    search: 'Поиск юнитов',
                    addTypical: 'Добавить новый типовой юнит',
                    download: 'Скачать юниты',
                    uploadPlans: 'Загрузить планы',
                    updateRealUnitsCheckDateButton: 'Обновить дату последнего обновления на сегодня',
                    clearProjectStatisticButton: 'Очистить статистику',
                    deleteSoldOutUnitButton: 'Удалить проданный юнит',
                    updateTypicalUnitsDateTooltip: 'Обновить последнюю дату обновления на текущую',
                    notFilled: 'Не заполнено',
                    plan: 'План',
                    number: 'Номер',
                    type: 'Тип',
                    layout: 'Планировка',
                    height: 'Этажность',
                    floor: 'Этаж',
                    size: 'Площадь',
                    square: 'Площадь',
                    price: 'Цена',
                    features: 'Особенности',
                    view: 'Вид',
                    views: 'Виды',
                    action: 'Действия',
                    from: 'From',
                    to: 'To',
                    soldOut: 'Солдаут',
                    soldOutShow: 'Показать солдаут',
                    soldOutHide: 'Скрыть солдаут',
                    save: 'Сохранить',
                    heightsList,
                    ...units,
                    unitEdit: {
                        selectLayout: 'Выбор планировки',
                        layoutName: 'Имя планировки',
                        search: 'Поиск',
                        unitsList: 'Список юнитов',
                        type: 'Тип',
                        layout: 'Планировка',
                        height: 'Этажность',
                        features: 'Особенности',
                        floor: 'Этаж',
                        number: 'Номер',
                        square: 'Площадь',
                        price: 'Цена',
                        views: 'Виды',
                        save: 'Сохранить',
                        apply: 'Применить',
                        renderersShow: 'Все юниты',
                        renderersHide: 'Без планировок',
                        uploadError: 'Нельзя загрузить более 10 файлов за раз',
                        deleteDialog: {
                            title: 'Удаление юнита',
                            message: 'Вы уверены, что хотите удалить юнит? \nОн удалится полностью из системы после сохранения проекта! \nЕсли хотите перевести юнит в Sold Out - сделайте новую загрузку csv файла', // eslint-disable-line
                        },
                        noChanges: {
                            title: 'Изменений в файле не обнаружено',
                            footnote: 'Пожалуйста обновите файл перед тем, как продолжить.',
                        },
                    },
                    updateRealUnitsCheckDateDialog: {
                        title: 'Обновить дату последнего обновления',
                        text: 'Вы уверены, что хотите поменять дату обновления на текущую?',
                        successText: 'Обновление завершено!',
                        failText: 'Обновление не удалось: {{json}}',
                        cancel: 'Отмена',
                        update: 'Обновить',
                    },
                    clearStatisticDialog: {
                        title: 'Статистика проекта',
                        text: 'Вы уверены, что хотите очистить статистику по всему проекту?',
                        successText: 'Статистические данные были успешно очищены',
                        failText: 'Очистка не удалась: {{json}}',
                        clear: 'Очистить',
                    },
                    updateTypicalUnitsCheckDateDialog: {
                        title: 'Обновить дату последнего обновления',
                        text: 'Вы уверены, что хотите поменять дату обновления на текущую?',
                        successText: 'Обновление завершено!',
                        failText: 'Обновление не удалось: {{json}}',
                        cancel: 'Отмена',
                        update: 'Обновить',
                    },
                    deleteAllPlansDialog: {
                        title: 'Удалить все планировки?',
                        description: 'Вы уверены, что хотите удалить планировки всех юнитов в этом проекте? (кроме ресейл-юнитов)',
                        tryAgainBtn: 'Попробовать снова',
                    },
                    deleteSelected: 'Удалить выбранные',
                    deleteSelectedUnitsDialog: {
                        title: 'Удалить выбранные юниты',
                        description: 'Вы уверены, что хотите удалить выбранные юниты?',
                        cancel: 'Отмена',
                        delete: 'Удалить',
                    },
                    deleteSoldOutUnitDialog: {
                        title: 'Удалить распроданный юнит',
                        text: 'Введите номер юнита, чтобы удалить его',
                        inputPlaceholder: 'Номер юнита',
                        deleteButton: 'Удалить',
                        successText: 'Юнит был успешно удален',
                        failText: 'Удалить не удалось: {{message}}',
                        ok: 'Ок',
                    },
                    importSettingsModal: {
                        title: 'Установите валюту импорта и единицу площади',
                        projectLabel: 'Проект:',
                        noticeTitle: 'Постоянные настройки импорта',
                        noticeText: 'Эти настройки будут применены ко всем юнитам продавца в Sunti Residence и ко всем будущим импортам.' +
                            ' Цены и площади будут сохранены ровно в том виде, в каком они указаны в файлах, без конвертации. Эти настройки нельзя будет изменить позже в административном интерфейсе.',
                        currencyPlaceholder: 'Выберите валюту',
                        currencyTitle: 'Валюта',
                        areaUnitPlaceholder: 'Выберите единицу площади',
                        areaUnitTitle: 'Единица измерения площади',
                        cancel: 'Отменить импорт',
                        submit: 'Установить настройки',
                    },
                },
                amenitiesEditFailTitle: 'Ошибка обновления удобств',
                models3d: {
                    add: 'Новое здание',
                    units: 'юниты',
                    edit: 'Редактировать здание',
                    delete: 'Удалить здание',
                    published: 'Опубликовано',
                },
                catalogPreviewModal: {
                    title: 'Предпросмотр проекта',
                    bodyText: 'Открывается в новой вкладке и показывает, как проект будет выглядеть в каталоге. Предпросмотр отображает только сохраненные изменения.',
                    openPreview: 'Открыть в новой вкладке',
                    error: 'Ошибка',
                },
            },
            emirateEdit: {
                name: 'Имя',
                newEmirate: {
                    AE: 'Новый эмират',
                    default: 'Новый регион',
                },
                aboutEmirate: {
                    AE: 'Об эмирате',
                    default: 'О регионе',
                },
                emirateName: {
                    AE: 'Название эмирата',
                    default: 'Название региона',
                },
                selectColor: 'Выберите цвет',
                deleteConfirmationModal: {
                    title: {
                        AE: 'Удалить эмират?',
                        default: 'Удалить регион?',
                    },
                    description: {
                        AE: 'Вы уверены, что хотите удалить эмират?',
                        default: 'Вы уверены, что хотите удалить регион?',
                    },
                },
                create: 'Создать',
                save: 'Сохранить',
                location: 'Локация',
                add: 'Добавить',
            },
            districtEdit: {
                createDistrict: 'Создание района',
                editDistrict: 'Редактирование района',
                newDistrict: 'Новый район',
                photos: 'Фото',
                averagePrice: 'Средняя цена',
                aboutDistrict: 'О районе',
                districtName: 'Название района',
                name: 'Имя',
                description: 'Описание',
                selectColor: 'Выберите цвет',
                deleteConfirmationModal: {
                    title: 'Удалить район?',
                    description: 'Вы уверены, что хотите удалить район?',
                },
                deleteBlockedNotification: {
                    description: 'В районе есть проекты. Сначала удалите проекты',
                },
                create: 'Создать',
                save: 'Сохранить',
                addNewItems: {
                    title: 'Ключевые слова для поиска',
                    addText: 'Добавить',
                    placeholder: 'Введите название',
                    tooltip: 'Ключевые слова, по которым можно найти район в поиске.',
                },
                location: 'Локация',
                add: 'Добавить',
            },
            addNewItems: {
                title: 'Ключевые слова для поиска',
                addText: 'Добавить',
                placeholder: 'Введите название',
                tooltip: 'Ключевые слова, по которым можно найти проект в поиске.',
            },
            districtView: {
                description: 'Описание',
                descriptionHide: 'Скрыть',
                descriptionShow: 'Показать',
                developers: 'Застройщики',
                places: 'Места',
                projectsCount_one: '{{count}} проект',
                projectsCount_two: '{{count}} проекта',
                projectsCount_few: '{{count}} проекта',
                projectsCount_many: '{{count}} проектов',
                projectsCount_other: '{{count}} проектов',
                from: 'От',
            },
            projectView: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                description: 'Описание',
                descriptionHide: 'Скрыть',
                descriptionShow: 'Показать',
                floor: 'этаж',
                resale: 'Resale',
                distress: 'Distress',
                priceWithCommission: 'Цена с комиссией',
                priceWithoutCommission: 'Цена без комиссии',
                unitFeature: 'Особенность юнита',
                unitView: 'Вид из окна',
                currencyUpdatedDaily: 'обновляется ежедневно',
                unitContactsAria: 'Контакты по продаже юнита',
                unitContactsModalTitle: 'Контакты',
                unitContactsModalOk: 'Ок',
                fullUnitsList: 'Все юниты',
                addToCatalog: 'Проект в каталог',
                unitsOnRequestHint: {
                    start: 'Некоторые юниты в продаже от застройщика доступны по запросу у ',
                    link: 'менеджера',
                    end: '',
                },
                unitsOnRequestBlockTitle: 'Юниты по запросу',
                unitsOnRequestBlockTitleSome: 'Некоторые юниты от застройщика по запросу',
                unitsOnRequestBlockDescription: 'Свяжитесь с менеджером, чтобы получить подробности о юнитах в этом проекте.',
                tabs: {
                    information: 'Информация',
                    amenities: 'Удобства',
                    paymentPlans: 'План оплаты',
                    units: 'Юниты',
                    documentsAndVideos: 'Документы и видео',
                    seller: 'Продавец',
                    placesNearby: 'Места рядом',
                    transactions: 'Транзакции',
                },
                paymentMethods,
                information: {
                    developer: 'Застройщик',
                    district: 'Район',
                    price: 'Цена',
                    pricePerSquare: 'Цена за',
                    size: 'Площадь',
                    postHandover: 'Постоплата',
                    handover: {
                        title: 'Готовность',
                        ready: 'Сдан',
                    },
                    ownershipType: {
                        title: 'Тип владения',
                        leasehold: 'Арендное владение',
                        freehold: 'Полная собственность',
                    },
                    unitType: 'Тип юнита',
                    serviceCharge: {
                        TH: 'Обслуживание',
                        default: 'Обслуживание',
                    },
                    furnishing: 'Отделка',
                    startOfSales: 'Старт продаж',
                    eoi: {
                        title: {
                            MX: 'Платёж за бронирование',
                            default: 'Взнос по EOI',
                        },
                        from: 'От',
                        upTo: 'До',
                        hint: {
                            MX: 'Итоговая сумма платежа за бронирование зависит от выбранного юнита и условий продавца.',
                            default: 'Итоговая сумма EOI зависит от выбранного юнита и условий продавца.',
                        },
                    },
                    noc: 'Resale доступен после',
                    projectConfigurations: 'Конфигурации проекта',
                    managersContacts: 'Контакты застройщика',
                    managersName: 'Имя',
                    managersPhone: 'Телефон',
                    hide: 'Скрыть',
                    show: 'Показать',
                    yes: 'Да',
                    no: 'Нет',
                },
                units: {
                    ...units,
                    from: 'от',
                },
                paymentPlans: {
                    postHandover: 'С пост оплатой',
                    noPostHandover: 'Без пост оплаты',
                    payment_one: '{{count}} платеж',
                    payment_few: '{{count}} платежа',
                    payment_many: '{{count}} платежей',
                    payment_other: '{{count}} платежей',
                    times_one: '({{count}} повтор раз в {{intervalType}})',
                    times_few: '({{count}} повтора раз в {{intervalType}})',
                    times_many: '({{count}} повторов раз в {{intervalType}})',
                    times_other: '({{count}} повторов раз в {{intervalType}})',
                    type_day_one: '{{count}} день',
                    type_day_few: '{{count}} дня',
                    type_day_many: '{{count}} дней',
                    type_day_other: '{{count}} дней',
                    type_week_one: '{{count}} неделю',
                    type_week_few: '{{count}} недели',
                    type_week_many: '{{count}} недель',
                    type_week_other: '{{count}} недель',
                    type_month_one: '{{count}} месяц',
                    type_month_few: '{{count}} месяца',
                    type_month_many: '{{count}} месяцев',
                    type_month_other: '{{count}} месяцев',
                    type_year_one: '{{count}} год',
                    type_year_few: '{{count}} года',
                    type_year_many: '{{count}} лет',
                    type_year_other: '{{count}} лет',
                    ready: 'готово',
                },
                seller: {
                    salesManagers: 'Менеджеры по продажам',
                    salesManagersDescription: 'Контакты',
                    resaleContactsHint: 'Контакты для ресейл юнитов указаны в его карточке.',
                    commission: 'Комиссия',
                    commissionDescription: 'Применимая комиссия',
                    commissionItemDescription: 'Ставка на сделки',
                    address: 'Расположение офиса',
                    descriptionShow: 'Показать',
                    descriptionHide: 'Скрыть',
                    clipboard: 'Скопировано!',
                },
                floorsList,
                heightsList,
                placesNearby: {
                    meters: 'метров',
                },
                transactions: {
                    empty: {
                        header: 'Статистики еще нет',
                        subheader: 'Мы работаем над этим',
                        noData: 'Нет данных',
                        noDataChart: 'Нет данных. Пожалуйста, измените фильтры чтобы увидеть статистику.',
                    },
                    tab: {
                        header: 'Итог за все время',
                        subheader: 'Нажмите на кнопку внизу, чтобы увидеть детализированную информацию.',
                        price: 'Медианная цена',
                        priceRatio: 'Медианная цена/{{square}}',
                        transactions: 'Транзакции',
                        modalButton: 'Полная информация',
                    },
                    modal: {
                        table: {
                            saleType: 'Тип продажи',
                            type: 'Тип',
                            layouts: 'Планировки',
                            size: 'Площадь',
                            price: 'Цена',
                            salesDate: 'Дата продажи',
                            resale: 'Перепродажа',
                            firstSale: 'Первая продажа',
                        },
                        filters: {
                            period: 'Период',
                            interval: 'Интервал',
                            periodFilter: 'За год',
                            dateFrom: "Дата от",
                            dateTo: "Дата до",
                            selectLayout: 'Все планировки',
                            selectType: 'Все типы',
                            saleType: 'Все типы продажи',
                            allTime: 'Все время',
                            resale: 'Перепродажа',
                            firstSale: 'Первая продажа',
                            filtersValues: {
                                periods: {
                                    'week': 'За неделю',
                                    'month': 'За месяц',
                                    '3months': 'За 3 месяца',
                                    '6months': 'За 6 месяцев',
                                    'year': 'За год',
                                    'allTime': 'За все время',
                                    'range': 'Выбрать даты',
                                },
                                intervals: {
                                    'day': 'День',
                                    'week': 'Неделя',
                                    'month': 'Месяц',
                                    'quarter': 'Квартал',
                                    'year': 'Год',
                                },
                                layouts: {
                                    'all': 'Все планировки',
                                    'Studio': 'Студия',
                                    'Office': 'Офис',
                                    'Retail': 'Ритейл',
                                    '1': '1 спальня',
                                    '2': '2 спальни',
                                    '3': '3 спальни',
                                    '4': '4 спальни',
                                    '5': '5 спален',
                                    'PLUS_6': '6+ спален',
                                },
                                types: {
                                    'all': 'Все типы',
                                    '213': 'Апартаменты',
                                    '215': 'Вилла',
                                    '217': 'Участок земли',
                                    '218': 'Коммерческая',
                                },
                                saleTypes: {
                                    'all': 'Все типы продаж',
                                    '0': 'Первая продажа',
                                    '1': 'Ресейл',
                                },
                            },
                        },
                    },
                },
            },
            filters: {
                byLocation: {
                    title: 'Локация',
                    reset: 'Сбросить локацию',
                },
                byCompany: {
                    title: 'Компания',
                    reset: 'Сбросить компанию',
                },
                other: {
                    title: 'Основные фильтры',
                    reset: 'Сбросить всё',
                },
            },
            fullUnitsList: {
                ...units,
                floorPlan: 'План',
                number: 'Номер',
                type: 'Тип',
                layout: 'Комнаты',
                unitHeight: 'Этажность',
                floor: 'Этаж',
                size: 'Площадь',
                price: 'Стоимость',
                view: 'Вид из окна',
                action: 'Действие',
                searchPlaceholder: 'Поиск по юнитам',
                pricePerSquare: 'Цена за',
                priceWithCommission: 'Цена с комиссией',
                priceWithoutCommission: 'Цена без комиссии',
                distress: 'Distress',
                floorsList,
                heightsList,
                unitsOnRequestHint: {
                    start: 'Некоторые юниты в продаже от застройщика доступны по запросу у ',
                    link: 'менеджера',
                    end: '',
                },
            },
            blockCompanyGap: {
                text_one: ' {{count}} день осталось до окончания срока текущей подписки. Для продления доступа, обратитесь к вашему менеджеру.',
                text_few: ' {{count}} дня осталось до окончания срока текущей подписки. Для продления доступа, обратитесь к вашему менеджеру.',
                text_many: ' {{count}} дней осталось до окончания срока текущей подписки. Для продления доступа, обратитесь к вашему менеджеру.',
                text_other: ' {{count}} дней осталось до окончания срока текущей подписки. Для продления доступа, обратитесь к вашему менеджеру.',
            },
            statistics: {
                tooltipText: 'С прошлого обновления',
                tooltipPreLaunchText: 'Начальная стоимость',
                chartPreLaunchPointText: 'Старт продаж',
            },
            leftPanel: {
                project: 'Проект',
                district: 'Район',
                region: 'Регион',
                place: 'Место',
                filter: 'Фильтры',
                '3D': '3D',
            },
        },
        personal: {
            companies: {
                title: 'Компании',
                add: 'Добавить компанию',
                tag_one: '{{count}} компания',
                tag_few: '{{count}} компании',
                tag_many: '{{count}} компаний',
                tag_other: '{{count}} компаний',
                broker: 'Брокер',
                developer: 'Застройщик',
                agency: 'Агентство',
                blocked: 'Заблокированные',
                active: 'Активные',
                notAssigned: 'Не назначен',
                all: 'Все',
                searchPlaceholder: 'Поиск',
                typePlaceholder: 'Тип',
                contentManagerPlaceholder: 'Контент-менеджер',
                salesManagerPlaceholder: 'Менеджер по продажам',
                statusPlaceholder: 'Статус',
                titles: {
                    status: 'Статус',
                    logo: 'Лого',
                    name: 'Название',
                    type: 'Тип',
                    employees: 'Сотрудники',
                    blocking: 'Блокировка',
                    contentManager: 'Контент',
                    salesManager: 'Продажи',
                    change: 'Изменить',
                },
                editCompany: {
                    company: 'Компания',
                    type: 'Тип компании',
                    agent: 'Агент',
                    developer: 'Застройщик',
                    basicInformation: {
                        title: 'Основная информация',
                        name: {
                            title: 'Название компании',
                            placeholder: 'Название',
                        },
                        description: {
                            title: 'Описание {{chars}}/{{maxChars}}',
                            placeholder: 'Максиммум 500 символов',
                        },
                        maxUsersCount: {
                            title: 'Максимальное количество пользователей',
                            placeholder: 'До 100',
                        },
                        site: {
                            title: 'Сайт',
                            placeholder: 'Вставьте ссылку',
                        },
                        address: {
                            broker: {
                                title: 'Адрес компании',
                                placeholder: 'Введите адрес',
                            },
                            developer: {
                                title: 'Адрес офиса продаж',
                                placeholder: 'Введите адрес',
                            },
                        },
                    },
                    blocking: {
                        title: 'Блокировка',
                        expiredAt: {
                            title: 'Дата блокировки',
                            hint: 'Блокировка произойдёт в 00:00 по UTC указанной даты',
                        },
                    },
                    resale: {
                        title: 'Доступ к ресейлу',
                        maxUnits: {
                            title: 'Количество ресейл юнитов',
                            placeholder: '0',
                        },
                    },
                    contacts: {
                        title: 'Контакты офиса продаж',
                        name: {
                            title: 'Имя менеджера',
                            placeholder: 'John Smith',
                        },
                        phone: {
                            title: 'Телефон',
                        },
                    },
                    responsible: {
                        title: 'Ответственные сотрудники',
                        searchPlaceholder: 'Поиск',
                        notAssigned: 'Не назначен',
                        content: {
                            title: 'Контент менеджер',
                            placeholder: 'Выбрать сотрудника',
                        },
                        sales: {
                            title: 'Менеджер по продажам',
                            placeholder: 'Выбрать сотрудника',
                        },
                    },
                    create: 'Создать',
                    save: 'Сохранить',
                    analyticsMetrics: {
                        title: 'Доступ в сервис метрик',
                    },
                    addNewItems: {
                        title: 'Ключевые слова для поиска',
                        addText: 'Добавить',
                        placeholder: 'Введите название',
                        tooltip: 'Ключевые слова, по которым можно найти проект в поиске.',
                    },
                    countries: {
                        title: 'Доступные страны',
                        placeholder: 'Выберите страны',
                    },
                    deleteDialog: {
                        title: 'Удалить компанию?',
                        text: 'Компания будет удалена, восстановить будет сложно.',
                        cancel: 'Отмена',
                        confirm: 'Подтверждаю',
                    },
                    deleteErrorDialog: {
                        title: 'Компания не может быть удалена',
                        ok: 'Ок',
                    },
                },
            },
            employees: {
                count_one: '{{count}} cотрудник',
                count_few: '{{count}} cотрудникa',
                count_many: '{{count}} cотрудников',
                count_other: '{{count}} cотрудников',
                createUser: 'Создать пользователя',
                inviteUser: 'Пригласить пользователя',
                delete: 'Удалить',
                edit: 'Изменить',
                changePassword: 'Изменить пароль',
                companySelectionRequired: 'Необходимо выбрать компанию',
                employees: 'Сотрудники',
                requests: 'Заявки',
                reject: 'Отклонить',
                approve: 'Одобрить',
                role: 'Роль',
                userSearch: 'Поиск пользователей',
                editEmployee: {
                    broker: 'Пользователь',
                    head_of_sales_department: 'Администратор',
                    admin: 'Верховный администратор',
                    additionalContacts: 'Дополнительные контакты',
                    user: 'Пользователь',
                    name: 'Имя',
                    namePlaceholder: 'Иван Иванов',
                    email: 'Адрес почты',
                    emailPlaceholder: 'ivan@company.com',
                    phone: 'Телефон',
                    password: 'Пароль',
                    role: 'Роль',
                    create: 'Создать',
                    edit: 'Изменить',
                    add: 'Добавить',
                    tg: 'Telegram',
                    whatsapp: 'WhatsApp',
                    instagram: 'Instagram',
                    roles,
                    requiredField: 'Поле обязательно для заполнения.',
                    hint: 'Новый пароль должен быть не менее 8 символов и включать хотя бы одну заглавную и строчную букву, цифру и символ.',
                    mainInfo: 'Основная информация',
                    passwordInfo: 'Придумайте новый пароль',
                },
                changeEmployeePassword: {
                    header: 'Изменение пароля',
                    description: 'Новый пароль должен быть не менее 8 символов и включать хотя бы одну заглавную и строчную букву, цифру и символ.',
                    uppercaseAndLowercaseLetterTitle: 'Пароль обязательно должен содержать минимум одну строчную и одну заглавную букву.',
                    oneDigitTitle: 'Пароль обязательно должен содержать минимум одну цифру.',
                    specialSymbolTitle: 'Пароль обязательно должен содержать минимум один специальный символ.',
                    minimumLengthTitle: 'Длина пароля обязательно должна быть не менее 8 символов.',
                    newPasswordPlaceholder: 'Новый пароль',
                    confirmedNewPasswordPlaceholder: 'Подтвердите новый пароль',
                    shortPasswordError: 'Пароль должен содержать не менее 8 символов.',
                    submitButton: 'Изменить пароль',
                },
                roles: {
                    all: 'Все',
                    broker: 'Пользователь',
                    head_of_sales_department: 'Администратор',
                    admin: 'Верховный администратор',
                },
                inviteDropdown: {
                    share: 'Поделиться ссылкой на приглашене',
                    downloadQR: 'Скачать QR-код',
                    copyLink: 'Скопировать ссылку',
                    copyLinkSuccess: 'Ссылка скопирована',
                    refreshLink: 'Обновить ссылку',
                },
                headers: {
                    photo: 'Фото',
                    name: 'Имя',
                    role: 'Роль',
                    email: 'Почта',
                    phone: 'Телефон',
                    active: 'Активный',
                    actions: 'Действия',
                },
                approveConfirmation: {
                    header: 'Одобрить запрос?',
                    description: 'Вы уверены, что хотите одобрить запрос от:\n{{name}}?',
                    accept: 'Да',
                    cancel: 'Нет',
                },
                approveError: {
                    header: 'Что-то пошло не так',
                    description: 'Произошла ошибка при выполнении действия. Пожалуйста, обратитесь в поддержку',
                },
                rejectConfirmation: {
                    header: 'Отклонить запрос?',
                    description: 'Вы уверены, что хотите отклонить запрос от:\n{{name}}?',
                    accept: 'Да',
                    cancel: 'Нет',
                },
                createEmployeeDialog: {
                    title: 'Создание пользователя',
                    somethingWentWrong: 'Что-то пошло не так',
                },
            },
            catalog: {
                catalog: 'Каталог',
                clear: 'Очистить',
                preview: 'Предпросмотр',
                settings: 'Настройки',
                create: 'Создать каталог',
                created: 'Каталог сформирован',
                createdError: {
                    title: 'Ошибка создания каталога',
                    description: 'Попробуйте еще раз или повторите попытку позже',
                },
                modal: {
                    title: 'Укажите параметры каталога',
                    layoutImage: 'С планировками',
                    layoutTable: 'Таблицей',
                    darkTheme: 'Тёмная тема',
                    lightTheme: 'Светлая тема',
                    withMap: 'Локация проекта с описанием района',
                    hideUnitsNumbers: 'Скрыть номера юнитов',
                    withDeveloper: 'Описание застройщика',
                    save: 'Сохранить',
                    cancel: 'Отменить',
                },
                empty: {
                    title: 'Ваш каталог пуст',
                    description: 'Добавьте проекты или объекты из карты, чтобы начать работать с вашим каталогом',
                    button: 'Перейти на карту',
                },
                project: 'Проект',
                number: 'Номер',
                type: 'Тип',
                layout: 'Планировка',
                height: 'Этажность',
                floor: 'Этаж',
                size: 'Площадь',
                pricePerSquare: 'Цена за',
                price: 'Цена',
                action: 'Действия',
                heightsList,
                ...floorsList,
                yes: 'Да',
                no: 'Нет',
                noDataTitle: 'В каталоге ничего нет',
                noDataDescription: 'Добавьте юниты в каталог, выбрав их на карте',
            },
            files: {
                files: 'Файлы',
                addFolder: 'Добавить папку',
                addFile: 'Добавить файл',
            },
            menu: {
                profile: 'Мой профиль',
                places: 'Места',
                amenities: 'Удобства',
                companies: 'Компании',
                employees: 'Сотрудники',
                files: 'Файлы',
                catalog: 'Каталог',
                resale: 'Resale',
                toTheMap: 'К карте',
            },
            profile: {
                changePassword: 'Изменить пароль',
                logout: 'Выйти',
                cancel: 'Сбросить',
                save: 'Сохранить',
            },
            amenities: {
                title: 'Удобства',
                actions: {
                    createAmenity: 'Создать удобство',
                    createType: 'Создать новый тип',
                    loadAmenities: 'Скачать удобства как CSV',
                    loadTypes: 'Скачать типы как CSV',
                },
                filters: {
                    typeSearch: 'Поиск типа',
                    amenitiesSearch: 'Поиск удобств',
                    types: 'Типы',
                },
                empty: {
                    title: 'Результат не найден',
                    description: 'Попробуйте изменить параметры поиска',
                    clean: 'Очистить',
                },
                list: {
                    title: 'Удобства',
                    count_one: '{{count}} элемент',
                    count_few: '{{count}} элемента',
                    count_many: '{{count}} элементов',
                    count_other: '{{count}} элементов',
                    icon: 'Иконка',
                    name: 'Имя',
                    category: 'Категория',
                    edit: 'Редактировать',
                    editAmenity: 'Редактировать удобство',
                    deleteAmenity: 'Удалить удобство',
                    deleteDialog: {
                        title: 'Удалить удобство',
                        message: 'Вы уверены, что хотите удалить удобство?',
                        cancel: 'Отменить',
                        delete: 'Удалить',
                    },
                },
                types: {
                    title: 'Типы',
                    count_one: '{{count}} категория',
                    count_few: '{{count}} категории',
                    count_many: '{{count}} категорий',
                    count_other: '{{count}} категорий',
                    icon: 'Иконка',
                    name: 'Имя',
                    amenitiesCount: 'Количество удобств',
                    edit: 'Редактировать',
                    editType: 'Редактировать тип',
                    deleteType: 'Удалить тип',
                    deleteDialog: {
                        title: 'Удалить тип',
                        message: 'Вы уверены, что хотите удалить тип?',
                        cancel: 'Отмена',
                        delete: 'Удалить',
                    },
                    deleteBlockedNotification: {
                        description: 'Невозможно удалить тип, в типе присутствуют удобства',
                    },
                },
                editTypeModal: {
                    editTitle: 'Изменить тип',
                    createTitle: 'Новый тип',
                    subtitle: 'Убедитесь, что наименование типа уникально и не совпадает ни с одним из существующих.',
                    nameEnTitle: 'Наименование типа на английском',
                    nameRuTitle: 'Наименование типа на русском',
                    namePlaceholder: 'Наименование типа',
                    save: 'Сохранить',
                },
                editAmenityModal: {
                    editTitle: 'Редактировать удобство',
                    createTitle: 'Новое удобство',
                    nameSectionTitle: 'Наименование',
                    nameEnTitle: 'Наименование удобства на английском',
                    nameRuTitle: 'Наименование удобства на русском',
                    namePlaceholder: 'Наименование удобства',
                    typeTitle: 'Тип',
                    typePlaceholder: 'Без типа',
                    save: 'Сохранить',
                },
            },
            places: {
                title: 'Места',
                actions: {
                    createPlace: 'Создать место',
                    createType: 'Создать новый тип',
                    loadPlaces: 'Загрузить места как CSV',
                    loadTypes: 'Загрузить типы как CSV',
                },
                filters: {
                    typeSearch: 'Поиск типа',
                    placesSearch: 'Поиск места',
                    emirates: {
                        AE: 'Эмираты',
                        default: 'Регионы',
                    },
                    districts: 'Районы',
                    categories: 'Категории',
                },
                list: {
                    title: 'Места',
                    count_one: '{{count}} место',
                    count_few: '{{count}} места',
                    count_many: '{{count}} мест',
                    count_other: '{{count}} мест',
                    icon: 'Иконка',
                    name: 'Имя',
                    edit: 'Редактировать',
                    emirates: {
                        AE: 'Эмираты',
                        default: 'Регионы',
                    },
                    districts: 'Районы',
                    categories: 'Категории',
                    deleteDialog: {
                        title: 'Удалить место',
                        message: 'Вы точно хотите удалить место?',
                        cancel: 'Отменить',
                        delete: 'Удалить',
                    },
                    editPlace: 'Редактировать место',
                    deletePlace: 'Удалить место',
                },
                editTypeModal: {
                    subtitle: 'Убедитесь, что наименование типа уникально и не совпадает ни с одним из существующих.',
                    nameSectionTitle: 'Наименование',
                    nameEnTitle: 'Наименование типа на английском',
                    nameRuTitle: 'Наименование типа на русском',
                    namePlaceholder: 'Наименование типа',
                    importantLabel: 'Важность типа',
                    editTitle: 'Изменить тип',
                    createTitle: 'Создать новый тип',
                    save: 'Сохранить',
                    hint: 'Важные места (торговые центры, школы, музеи) находятся в верхней части списка; менее важные (например, автобусная остановка) остаются в самом низу.',
                },
                types: {
                    title: 'Типы',
                    count_one: '{{count}} тип',
                    count_few: '{{count}} типа',
                    count_many: '{{count}} типов',
                    count_other: '{{count}} типов',
                    icon: 'Иконка',
                    name: 'Имя',
                    placesCount: 'Количество мест',
                    edit: 'Редактировать',
                    editType: 'Редактировать тип',
                    deleteType: 'Удалить тип',
                    deleteDialog: {
                        title: 'Удалить тип',
                        message: 'Места, относящиеся только к этому типу, будут отображаться без типа. Просто добавьте новый тип вручную при необходимости.',
                        cancel: 'Отмена',
                        delete: 'Удалить',
                    },
                },
                editCreatePlaceModal: {
                    createTitle: 'Новое место',
                    editTitle: 'Редактировать место',
                    save: 'Сохранить',
                    locationSectionTitle: 'Локация',
                    locationPlaceholder: 'Вставьте локацию или нажмите на карте, чтобы выбрать',
                    nameSectionTitle: 'Наименование',
                    namePlaceholder: 'Наименование места',
                    descriptionSectionTitle: 'Описание',
                    descriptionPlaceholder: 'Максимум 500 символов',
                    categoriesSectionTitle: 'Категории',
                    newCategory: 'Новая категория',
                    categoriesPlaceholder: 'Нет категорий',
                    photosSectionTitle: 'Фотографии',
                    uploadLabel: 'Загрузить файл',
                    categoriesDescription: 'Выберите иконку, которая будет видна пользователям',
                    nameEnTitle: 'Наименование типа на английском',
                    nameRuTitle: 'Наименование типа на русском',
                },
            },
            resale: {
                searchPlaceholder: 'Поиск по юниту',
                add: 'Добавить',
                statuses,
                status: 'Статус',
                project: 'Проект',
                number: 'Номер',
                price: 'Цена',
                square: 'Площадь',
                floor: 'Этаж',
                type: 'Тип',
                layout: 'Планировка',
                district: 'Район',
                edit: 'Редактировать',
                assignee: 'Менеджер',
                sold_out: 'Продан',
                downloadUnits: 'Скачать юниты',
                ...units,
                floorsList,
                addUnitModal: {
                    add: 'Добавить юнит',
                    edit: 'Изменить юнит',
                    tabs: {
                        commonData: {
                            name: 'Общие данные',
                            unitData: 'Данные юнита',
                            project: 'Проект',
                            projectPlaceholder: 'Выберите проект',
                            searchProjectInputPlaceholder: 'Название проекта',
                            projectNoOptionsText: 'Если нужный проект отсутствует в списке, свяжитесь с поддержкой через чат.',
                            unitNumber: 'Номер юнита',
                            unitNumberPlaceholder: 'Введите номер',
                        },
                        unitDetails: {
                            name: 'Детали юнита',
                            unitSpecification: 'Спецификация юнита',
                            square: 'Площадь в ft²',
                            squareShort: 'Площадь',
                            squarePlaceholder: '0 ft²',
                            amountPlaceholder: '0',
                            unitType: 'Тип юнита',
                            unitTypePlaceholder: 'Выберите тип юнита',
                            rooms: 'Количество комнат',
                            roomsPlaceholder: 'Выберите количество комнат',
                            height: 'Этажность',
                            heightPlaceholder: 'Выберите этажность',
                            internalFloor: 'Приблизительный этаж',
                            internalFloorPlaceholder: 'Выберите этаж',
                            floor: 'Этаж',
                            floorPlaceholder: 'Номер этажа',
                            view: 'Вид',
                            viewPlaceholder: 'Перечислите через запятую',
                            unitFeatures: 'Особенности юнита',
                            unitFeaturesPlaceholder: 'Выберите особенности юнита',
                            priceWithCommission: 'Цена с комиссией',
                            price: 'Стоимость в AED',
                            priceShort: 'Стоимость',
                            pricePlaceholder: '0 AED',
                            documents: 'Документы',
                            documentTemplate: 'Listing validation form',
                            firstDocumentPlaceholder: 'Oqood/Tittle deed/SPA',
                            secondDocumentPlaceholder: 'Validation form (Contract A)',
                            duplicateFilesError: 'Файлы должны быть разными',
                            layouts: 'Планировки',
                            layoutsPlaceholder: 'Выберите изображение',
                            attachLayoutsHint: 'Необходимо загрузить планировку(-и) юнита. Загрузка рендеров проекта и иных фотографий недопустима.',
                            distress: 'Distress',
                            distressHint: 'Distress - юнит цена которого равна или ниже Original price',
                            markAsDistress: 'Отметить как дистерсс',
                            floorsList,
                            heightsList,
                        },
                    },
                    button: {
                        next: 'Продолжить',
                        create: 'Создать',
                        toModeration: 'На модерацию',
                        save: 'Сохранить',
                    },
                    statuses: {
                        title: 'Статус',
                        ...statuses,
                    },
                },
                changeStatusUnitModal: {
                    status: 'Статус',
                    distress: 'Distress',
                    project: 'Проект',
                    unitNumber: 'Номер юнита',
                    square: 'Площадь',
                    floor: 'Этаж',
                    unitType: 'Тип юнита',
                    rooms: 'Количество комнат',
                    height: 'Этажность',
                    price: 'Стоимость',
                    firstDocument: 'Oqood/Title deed',
                    secondDocument: 'Validation form',
                    layouts: 'Планировки',
                    declineReason: 'Причина отклонения',
                    deleteConfirmation: 'Уверены, что хотите удалить юнит?',
                    soldOutConfirmation: 'Уверены, что хотите изменить статус юнита?',
                    view: 'Вид',
                    features: 'Особенности юнита',
                    floorsList,
                    heightsList,
                    statuses,
                    buttons: {
                        decline: 'Отклонить',
                        publish: 'Опубликовать',
                        delete: 'Удалить',
                        soldOut: 'Продан',
                        unpublish: 'Снять с публикации',
                    },
                },
                declineReasonModal: {
                    header: 'Причина отказа',
                    close: 'Закрыть',
                },
                unitsLimitReachedModal: {
                    header: 'Лимит исчерпан',
                    text_one: 'Вы достигли лимита в {{count}} юнит. Пожалуйста, свяжитесь с вашим администратором.',
                    text_few: 'Вы достигли лимита в {{count}} юнитa. Пожалуйста, свяжитесь с вашим администратором.',
                    text_many: 'Вы достигли лимита в {{count}} юнитов. Пожалуйста, свяжитесь с вашим администратором.',
                    text_other: 'Вы достигли лимита в {{count}} юнитов. Пожалуйста, свяжитесь с вашим администратором.',
                    close: 'Закрыть',
                },
                downloadResaleUnitModal: {
                    title: 'Скачать юниты',
                    submit: 'Скачать Excel таблицу',
                    message: 'Выберите параметры для отображения в таблице.',
                    successMessage: 'Таблица успешно скачана! Проверьте загрузки вашего браузера.',
                    ok: 'Ok',
                    columns: {
                        project: 'Проект',
                        price: 'Цена AED',
                        area: 'Площадь ft²',
                        districtName: 'Район',
                        unitType: 'Тип',
                        unitLevel: 'Этаж',
                        unitFeature: 'Особенности юнита',
                        unitNumber: 'Номер юнита',
                        unitStatus: 'Статус',
                        unitLayout: 'Планировка',
                        assignUserName: 'Назначен',
                    },
                },
            },
        },
        login,
        resetPassword: {
            passwordReset: {
                header: 'Восстановление пароля',
                body: 'Создайте новый пароль. Он должен быть не менее 8 символов и включать хотя бы одну заглавную и строчную букву, цифру и символ.',
                uppercaseAndLowercaseLetterTitle: 'Пароль обязательно должен содержать минимум одну строчную и одну заглавную букву.',
                oneDigitTitle: 'Пароль обязательно должен содержать минимум одну цифру.',
                specialSymbolTitle: 'Пароль обязательно должен содержать минимум один специальный символ.',
                minimumLengthTitle: 'Длина пароля обязательно должна быть не менее 8 символов.',
                password: 'Новый пароль',
                passwordConfirmation: 'Подтвердите новый пароль',
            },
            passwordSubmited: {
                header: 'Теперь у вас новый пароль!',
                body: 'Новый пароль успешно создан, теперь вы можете  использовать его для входа в Geniemap.',
            },
            createPassword: 'Создать пароль',
            ok: 'Ок',
        },
        registration: {
            invalidLink: {
                title: 'Неверная ссылка',
                description: 'К сожалению, вы получили недействительную ссылку. Попросите администратора предоставить вам новую.',
            },
            title: 'Создание учетной записи',
            description: 'Выполните все шаги, чтобы подать заявку на учетную запись GenieMap',
            step: 'Шаг {{step}}/{{steps}}',
            continue: 'Продолжать',
            step1: {
                emailError: 'Адрес электронной почты недействителен или уже занят.',
            },
            step2: {
                firstName: 'Имя',
                lastName: 'Фамилия',
                phone: 'Номер телефона',
            },
            step3: {
                password: 'Пароль',
                passwordConfirmation: 'Подтверждение пароля',
                uppercaseAndLowercaseLetterTitle: 'Пароль должен содержать как минимум одну строчную и одну заглавную букву.',
                oneDigitTitle: 'Пароль должен содержать хотя бы одну цифру.',
                specialSymbolTitle: 'Пароль должен содержать хотя бы один специальный символ.',
                minimumLengthTitle: 'Длина пароля должна быть не менее 8 символов.',
            },
            step4: {
                description: 'Мы отправили вам письмо с подтверждением на ваш почтовый ящик. Откройте письмо и нажмите на ссылку, чтобы отправить запрос.',
                button: 'Повторно отправить ссылку для подтверждения',
                counter_one: 'Вы можете повторно отправить ссылку через {{count}} секунду',
                counter_few: 'Вы можете повторно отправить ссылку через {{count}} секунды',
                counter_many: 'Вы можете повторно отправить ссылку через {{count}} секунд',
                counter_other: 'Вы можете повторно отправить ссылку через {{count}} секунд',
            },
            emailVerified: {
                success: {
                    title: 'Запрос отправлен',
                    subTitle: 'Ваш запрос был успешно применен.',
                    description: 'Пожалуйста, подождите, пока ваш администратор одобрит запрос. Вы будете уведомлены по электронной почте.',
                },
                error: {
                    title: 'Неверная ссылка для проверки',
                    subTitle: 'Эта ссылка для проверки либо устарела, либо недействительна. Пожалуйста, запросите новую, чтобы завершить проверку электронной почты.',
                },
            },
        },
        projectsList: {
            projects: '',
            projects_one: '{{ found }} из {{ count }} проекта',
            projects_few: '{{ found }} из {{ count }} проектов',
            projects_many: '{{ found }} из {{ count }} проектов',
            projects_other: '{{ found }} из {{ count }} проектов',
            noResultsFound: 'Результат не найден',
            tryDifferentSearchOptions: 'Попробуйте использовать другие поисковые опции',
            project: {
                tags: {
                    developerStock: 'DEVELOPER STOCK',
                    resale: 'RESALE',
                    preLaunch: 'PRE-LAUNCH',
                    soldOut: 'SOLD OUT',
                },
                priceFrom: 'Цена от',
                handover: 'Передача',
            },
        },
        common: {
            header: {
                logout: 'Выйти',
                searchButton: 'Поиск',
                locationButton: 'Локация',
                companyButton: 'Компания',
                mainFiltersButton: 'Основные фильтры',
                clearButton: 'Очистить',
                searchPlaceholder: 'Поиск по названию проекта или застройщика',
            },
            uploadArea: {
                invalidFileType: 'Неверный формат файла.',
                invalidFileSize: 'Файл не должен быть больше 5 МБ.',
                availableActions: 'Загрузить или вставить',
                add: 'Добавить',
                upload: 'Загрузить',
            },
            input: {
                noMatch: 'Нет совпадений',
            },
            uploadModal: {
                description: 'Описание',
                cancel: 'Отмена',
                save: 'Сохранить',
            },
            confirmModal: {
                cancel: 'Отмена',
                confirm: 'Подтвердить',
                ok: 'Ок',
            },
            authError: 'Ошибка авторизации',
            uploadPhoto: {
                wrongString: 'Некорректный формат строки максимального размера рендера: {{renderMaxSize}}',
                wrongSize: 'Поле не должно быть больше 5мб.',
            },
            select: {
                noSelected,
            },
            passwordRecoveryModal,
            changePasswordModal,
            editImage,
            profileForm,
            catalogSettingsModal,
            filters,
            measures,
            countries,
            autocomplete,
            alertDialog,
        },
        ws: {
            catalog: {
                start_catalog_generate: 'Каталог начал генерироваться.',
                catalog_generated: 'Каталог успешно создан',
                warning: 'Предупреждение',
            },
            auth: {
                logout: 'Вы были разлогинены в связи с большим количеством подключений из под вашего аккаунта.',
            },
        },
    },
};
